import React from "react";
import Zoom from "react-reveal/Zoom";
import Slide from "react-reveal/Slide";
import Fade from "react-reveal/Fade";
import { Alert } from "react-bootstrap";
import useMouseScroll from "../hooks/useMouseScroll";

const ErrorBox = () => (
   <Alert variant="danger">
      <Alert.Heading>Animation Component Props error</Alert.Heading>
      <div>
         EX:{" "}
         <div>
            &lt;Animation (slide , zoom) (left , bottom ,top , right) &gt; <br />
            &nbsp;&nbsp;&nbsp;&nbsp;{`{children}`} <br /> &lt;/Animation&gt;
         </div>
      </div>
   </Alert>
);
function Animation(props) {
   const { scroll } = useMouseScroll();
   if (props?.zoom) {
      const { zoom, ...params } = props;
      return (
         <Zoom {...params}>
            <>{props?.children}</>
         </Zoom>
      );
   }
   if (props?.fade) {
      const { fade, ...params } = props;
      return (
         <Fade {...params}>
            <>{props?.children}</>
         </Fade>
      );
   }
   if (props?.slide) {
      const { slide, ...params } = props;
      return (
         <Slide {...params}>
            <>{props?.children}</>
         </Slide>
      );
   }
   if (!props?.children) {
      return <ErrorBox />;
   }
   return <ErrorBox />;
}

export default Animation;
